/** @typedef {'low_stock' | 'overdue' | 'both'} NotificationReason */

export const NOTIFICATION_REASON_LABELS = {
  low_stock: 'Low stock',
  overdue: 'Overdue reorder',
  both: 'Low stock & overdue',
};

export const NOTIFICATION_REASON_BADGE_VARIANTS = {
  low_stock: 'warning',
  overdue: 'info',
  both: 'danger',
};

export const STOCK_MODE_LABELS = {
  packages: 'Packages',
  material: 'Material',
  kits: 'Kits',
};

/**
 * User-facing label for an order notification reason code.
 *
 * @param {string} [reason]
 * @returns {string}
 */
export function getNotificationReasonLabel(reason) {
  if (!reason) return 'Unknown';
  return NOTIFICATION_REASON_LABELS[reason] || reason;
}

/**
 * Bootstrap Badge variant for an order notification reason.
 *
 * @param {string} [reason]
 * @returns {string}
 */
export function getNotificationReasonBadgeVariant(reason) {
  if (!reason) return 'secondary';
  return NOTIFICATION_REASON_BADGE_VARIANTS[reason] || 'secondary';
}

/**
 * User-facing label for stock_mode from notification detail.
 *
 * @param {string} [stockMode]
 * @returns {string}
 */
export function getStockModeLabel(stockMode) {
  if (!stockMode) return '—';
  return STOCK_MODE_LABELS[stockMode] || stockMode;
}

/**
 * Format ISO updated_at for list/detail display.
 *
 * @param {string} [isoStr]
 * @returns {string}
 */
export function formatNotificationUpdatedAt(isoStr) {
  if (!isoStr) return '—';
  const date = new Date(isoStr);
  if (Number.isNaN(date.getTime())) return isoStr;
  return date.toLocaleString();
}
